// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.json-top-line {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background: white;\n    flex-shrink: 0;\n    opacity: 1;\n}\n.attr-json .codemirror-container {\n    margin-top: 4px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
